"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _qs = _interopRequireDefault(require("qs"));

var _isAuth0CallbackUrl = _interopRequireDefault(require("../isAuth0CallbackUrl"));

var _clientStorage = require("../clientStorage");

var _generateAuthStateKey = _interopRequireDefault(require("./generateAuthStateKey"));

var _getAuthStateKeys = _interopRequireDefault(require("./getAuthStateKeys"));

var _removeAuthStateKeys = _interopRequireDefault(require("./removeAuthStateKeys"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * stores the current url in local storage using a random string
 * (if config.redirectToCaller the browser is redirected here on successful login)
 */


var initializeAuthState = function initializeAuthState(clientStorageType) {
  // get existing auth state keys
  var existingAuthStateKeys = (0, _getAuthStateKeys.default)(clientStorageType);

  if ((0, _isAuth0CallbackUrl.default)() && existingAuthStateKeys.length) {
    // if auth state keys exists, and we are at an Auth0 callback URL, then use existing state from
    // client storage
    return existingAuthStateKeys[0];
  } // if we are not at an Auth0 Callback URL, but we have state keys, clear them as they are no
  // longer relevant because the redirectURL will be outdated


  if (existingAuthStateKeys.length) {
    (0, _removeAuthStateKeys.default)(clientStorageType);
  } // create a new state key, and write current URL to it


  var newAuthStateKey = (0, _generateAuthStateKey.default)(); // get the query params from the url

  var queryParams = _qs.default.parse(window.location.search, {
    ignoreQueryPrefix: true
  });

  var tenantId = queryParams.tenantId; // create state object to store at auth state key

  var stateObject = _objectSpread({
    redirectUrl: encodeURIComponent(window.location.href)
  }, tenantId && {
    tenantId: tenantId
  }); // write the state key/value to client storage


  switch (clientStorageType) {
    case _clientStorage.CLIENT_STORAGE_COOKIES:
      (0, _clientStorage.setItem)(newAuthStateKey, JSON.stringify(stateObject), _clientStorage.CLIENT_STORAGE_COOKIES);
      break;

    case _clientStorage.CLIENT_STORAGE_LOCAL_STORAGE:
      (0, _clientStorage.setItem)(newAuthStateKey, JSON.stringify(stateObject), _clientStorage.CLIENT_STORAGE_LOCAL_STORAGE);
      break;

    case _clientStorage.CLIENT_STORAGE_ALL:
    default:
      (0, _clientStorage.setItem)(newAuthStateKey, JSON.stringify(stateObject), _clientStorage.CLIENT_STORAGE_COOKIES);
      (0, _clientStorage.setItem)(newAuthStateKey, JSON.stringify(stateObject), _clientStorage.CLIENT_STORAGE_LOCAL_STORAGE);
  }

  return newAuthStateKey;
};

var _default = initializeAuthState;
exports.default = _default;